<i class="icon-close close-icon clickable" (click)="cancel()"></i>

<h3 mat-dialog-title>{{ 'POLICYHOLDER_CONTACT_DATA' | translate }}</h3>
<p>{{'MODAL.PROVIDE_POLICYHOLDER_CONTACT_DATA' | translate }}</p>

<div mat-dialog-content>
    <div class="row form-row" *ngIf="emailData">
        <div class="col-7">
            <app-input
                    [(ngModel)]="emailData.email"
                    [errorStateMatcher]="matchers.email"
                    [label]="'LABEL.EMAIL' | translate">
            </app-input>
        </div>
    </div>

    <p>{{'CLIENT_CONDITION_1' | translate}}</p>

    <div class="form-row">
        <div class="col">
            <app-checkbox
                    [(ngModel)]="emailData.clause"
                    [errorStateMatcher]="matchers.clause">{{'CLIENT_CONDITION_1' | translate}}
                <a href="javascript:"
                   *ngIf="extended === false"
                   (click)="extended = true"
                   class="link link-accent">{{'READ_MORE' | translate}}</a>
            </app-checkbox>
        </div>
    </div>

    <p class="checkbox-extend" *ngIf="extended">
        {{'CLIENT_CONDITION_1_EXTENDED' | translate }}
    </p>

</div>

<div mat-dialog-actions>
    <button type="button" class="btn btn-secondary" (click)="cancel()">
        {{ 'BUTTON.CANCEL' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
        {{ 'BUTTON.SAVE' | translate }}
    </button>
</div>

